var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgVideo(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 122,
    height: 123,
    viewBox: "0 0 122 123",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_57_321)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M49.8184 49.4485L49.5562 50.0142L42.0547 51.8224L39.7055 52.3982L38.4048 52.7114L36.9529 53.0649L35.4405 53.4286L34.7347 53.6003L33.4038 53.9236L22.2222 56.6612L30.7521 90.6741L30.8831 91.2297L24.2488 105.877L23.7043 105.544C20.4476 103.443 3.53903 91.068 2.63159 60.7928H2.77275C8.72151 59.2978 49.8184 49.4485 49.8184 49.4485Z",
    stroke: "white",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M76.1946 19.3854C76.1946 27.1538 76.1946 36.4777 76.2551 43.5591L65.5372 46.1654H65.4767L52.4298 36.3666",
    stroke: "#EF4255",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39.0199 25.8405L38.6972 25.598C38.1225 25.1434 37.5478 24.7091 36.9832 24.2848L25.2772 15.3042C25.2772 15.3042 42.7605 -2.03052 76.1643 5.07107V8.36428",
    stroke: "#EF4255",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M114.125 86.8758L94.5752 82.4512L106.009 79.5722L98.2957 48.7717L113.944 36.1949C113.944 36.1949 127.485 56.5703 114.125 86.8758Z",
    stroke: "#EF4255",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M73.2907 119.485C73.2907 119.485 49.7578 127.182 23.1295 106.857C23.2606 106.554 23.4522 106.14 23.6942 105.625C24.9848 102.857 27.7272 97.1494 30.752 90.7448L30.8831 91.3004L32.587 98.0686L59.3665 91.3307L65.3556 103.453L72.4135 117.646L73.2907 119.485Z",
    stroke: "#EF4255",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M65.8095 46.0442L65.4767 46.125L49.5562 50.0142L42.0447 51.8628L39.6954 52.4387L38.3947 52.7518L36.9428 53.1054L35.4304 53.469L34.7246 53.6408L33.3938 53.964L22.2121 56.7016L2.81308 61.4495C2.81308 61.4495 2.81309 61.2273 2.76268 60.8131C2.48036 56.9037 2.23839 35.7908 25.7713 15.7892C27.1324 16.7994 31.5486 20.1835 36.9832 24.2848C37.5478 24.7091 38.1225 25.1435 38.6972 25.5981L39.0199 25.8405L44.404 29.8812",
    stroke: "#EF4255",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M60.9999 120.98C93.5756 120.98 119.983 94.5215 119.983 61.8838C119.983 29.2462 93.5756 2.78809 60.9999 2.78809C28.4243 2.78809 2.01648 29.2462 2.01648 61.8838C2.01648 94.5215 28.4243 120.98 60.9999 120.98Z",
    stroke: "#EF4255",
    strokeWidth: 4,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.1819 56.5703V56.7016L33.3635 53.9641C26.709 55.5702 22.2625 56.6208 22.1819 56.5703Z",
    stroke: "#EF4255",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M98.2957 48.7717L95.7952 38.7911L76.255 43.5693L65.5372 46.1755L49.5461 50.0647L42.0446 51.873L39.6953 52.4488L38.3947 52.7619L36.9428 53.1155L35.4304 53.4792L34.7246 53.6509L33.3937 53.9741L22.212 56.7117L30.7419 90.7246L30.873 91.2802L32.577 98.0485L59.3565 91.3105L59.7699 91.2095L94.2021 82.5421L94.5752 82.4512L106.009 79.5722L98.2957 48.7717ZM61.8671 75.2789L56.2914 79.3197L54.8798 73.6727L51.492 60.1565L75.529 65.268L61.8671 75.2789Z",
    stroke: "#EF4255",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M79.2697 6.10153L84.311 13.294L78.8966 17.0923L79.2797 6.10153M78.1404 4.54578L77.2632 6.10153L76.8801 17.1024L76.749 21.1432L80.0561 18.8096L85.4705 15.0012L87.124 13.8496L85.9645 12.1929L80.9232 5.00043L80.0561 4.54578H78.1404Z",
    fill: "#EF4255"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.0085 45.1653L22.2322 56.2167L17.3119 49.1455L23.0085 45.1956M25.3276 41.1549L21.8692 43.549L16.1725 47.509L14.4786 48.6101L15.6281 50.2668L20.5383 57.3381L23.8051 62.0556L24.2084 56.338L24.9948 45.2765L25.2973 41.0741L25.3276 41.1549Z",
    fill: "#EF4255"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.8685 34.4069L38.0922 45.5795L30.389 50.9234L31.2461 39.7003L38.8685 34.4069ZM41.1674 30.3662L37.7191 32.7704L30.0966 38.0537L29.3001 38.6093L29.2295 39.569L28.3826 50.782L28.0599 55.0146L31.5385 52.6003L39.2416 47.2564L40.028 46.7008L40.0986 45.6907L40.875 34.5281L41.1674 30.3257V30.3662Z",
    fill: "#EF4255"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M55.9486 22.5069L55.2024 33.7199L46.3196 39.8821L47.1363 28.6185L55.9486 22.5574M58.2373 18.5166L54.8092 20.8199L45.997 26.9315L45.2004 27.4871L45.1299 28.4468L44.3031 39.68L44.0006 43.8925L47.459 41.4882L56.3519 35.316L57.1484 34.7604L57.2089 33.7502L57.955 22.5372L58.2373 18.355V18.5166Z",
    fill: "#EF4255"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.6657 56.0955L22.2725 55.5298L23.0186 45.4785L30.9939 39.9528L30.389 50.9133L22.6657 56.0955Z",
    stroke: "#EF4255",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.314 46.2401L38.8714 35.1684L47.3883 29.2953L46.7483 40.4293L38.3243 46.4684L38.314 46.2401Z",
    stroke: "#EF4255",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M71.0019 11.9101L70.2659 23.0221L63.2786 27.9417L64.0852 16.7488L71.0019 11.8798M73.2906 7.83903L69.8424 10.2635L62.9257 15.1224L62.1392 15.668L62.0687 16.6276L61.2621 27.8205L60.9596 32.0632L64.4381 29.6186L71.4254 24.7091L72.2219 24.1535L72.2824 23.1433L73.0184 12.0313L73.2906 7.82892V7.83903Z",
    fill: "#EF4255"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M79.2294 7.15214L78.8865 17.0924L70.4675 22.9009L70.9717 12.1728L79.2898 6.3642L79.2294 7.15214Z",
    stroke: "#EF4255",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M55.757 22.6988L55.1924 33.6896L63.4904 27.7093L64.0752 16.769L55.757 22.6988Z",
    stroke: "#EF4255",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M79.1268 5.1041L15.979 48.9293L22.0799 57.7536L85.2277 13.9283L79.1268 5.1041Z",
    stroke: "#EF4255",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_57_321"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 122,
    height: 123,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgVideo);
export default __webpack_public_path__ + "static/media/video.71341b0d12cd0e79ad5904bc5bd1a6a7.svg";
export { ForwardRef as ReactComponent };